import { Helmet } from "react-helmet-async";

const SITE = "https://natant.ai";
const OG_IMAGE = `${SITE}/og-image.png`;

export default function Seo({ title, description, path = "/", noindex = false }) {
        const url = `${SITE}${path}`;
        return (
                <Helmet>
                        <title>{title}</title>
                        <meta name="description" content={description} />
                        <meta name="robots" content={noindex ? "noindex, follow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
                        {!noindex && <link rel="canonical" href={url} />}

                        <meta property="og:type" content="website" />
                        <meta property="og:site_name" content="Natant AI Labs" />
                        <meta property="og:title" content={title} />
                        <meta property="og:description" content={description} />
                        <meta property="og:url" content={url} />
                        <meta property="og:image" content={OG_IMAGE} />
                        <meta property="og:image:width" content="1200" />
                        <meta property="og:image:height" content="630" />
                        <meta property="og:image:alt" content="Natant AI Labs — Become a Super Company" />
                        <meta property="og:locale" content="en_US" />

                        <meta name="twitter:card" content="summary_large_image" />
                        <meta name="twitter:title" content={title} />
                        <meta name="twitter:description" content={description} />
                        <meta name="twitter:image" content={OG_IMAGE} />
                </Helmet>
        );
}
